import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, catchError, of } from 'rxjs';
import {
    evaluatePartnerAccess,
    redirectToLogin,
    resolveFreshAuthUser,
} from './guard-auth.util';

export const partnerGuard: CanActivateFn = (_route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!localStorage.getItem('token')) {
        return of(redirectToLogin(router, state));
    }

    return authService.getUserInfo().pipe(
        map((response) => evaluatePartnerAccess(resolveFreshAuthUser(response), router, state)),
        catchError(() => of(redirectToLogin(router, state))),
    );
};
